import { useEffect, useMemo, useState } from "react";
import { Card, Container, Button, Form, Input, Label } from "reactstrap";
import { format } from "date-fns";
import { useLocation } from "react-router-dom";

import ReactTable from "components/ReactTable/ReactTable";
import useHelpers from "Hooks/useHelpers";
import useFetch from "Hooks/useFetch";
import styles from "./Support.module.css";
import IssueDetail from "./IssueDetail";
import useAlertContext from "Hooks/useAlertContext";

export default function Support() {
    const [issues, setIssues] = useState<IActiveIssue[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        subject: "",
        description: "",
        link: "",
    });

    const { newAlert } = useAlertContext();

    const query = new URLSearchParams(useLocation().search);

    const { handleFormChange } = useHelpers();
    const { get, post } = useFetch();

    // Get active DoneDone tickets on page load
    useEffect(() => {
        let ignore = false;
        getIssues();

        async function getIssues() {
            setIsLoading(true);
            const response = await get("/api/support/active_issues");
            const data = await response.json();
            console.log(data);

            if (ignore) return;

            if (response.ok) setIssues(data);

            setIsLoading(false);
        }

        return () => {
            ignore = true;
        };
    }, [get]);

    async function submitIssue(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        const id = query.get("id");
        const path = query.get("path");

        formData.link = `${path}/${id}`;
        const response = await post("/api/support/submit_issue", formData);
        const data = await response.json();
        console.log(data);

        if (response.ok) {
            newAlert({
                color: "info",
                message: "Issue Submitted",
            });
            setFormData({ subject: "", description: "", link: "" });
        } else {
            newAlert({
                color: "danger",
                message: "Issue could not be submitted",
            });
        }
    }

    const columns = useMemo(() => {
        return [
            {
                Header: "Issue",
                accessor: "title",
                Cell: ({ value, row }: { value: string; row: any }) => (
                    <IssueDetail
                        value={value}
                        description={row.original.description}
                    />
                ),
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: ({ value, row }: { value: string; row: any }) =>
                    row.original.status.name,
            },
            {
                Header: "Created",
                accessor: "created_on",
                Cell: ({ value }: { value: string }) =>
                    format(new Date(value), "EEE, MMM d, y"),
            },
            {
                Header: "Project",
                accessor: "project",
                Cell: ({ value, row }: { value: string; row: any }) =>
                    row.original.project.title,
            },
        ];
    }, []);

    return (
        <Container fluid>
            <h1>Create Support Ticket</h1>
            <Card className={styles.formBox}>
                <Form onSubmit={submitIssue}>
                    <Label htmlFor="subject" style={{ display: "none" }}>
                        Subject
                    </Label>
                    <Input
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={(e) => handleFormChange(e, setFormData)}
                        type="text"
                        placeholder="Subject"
                    />
                    <br />
                    <Label htmlFor="description" style={{ display: "none" }}>
                        Subject
                    </Label>
                    <textarea
                        id="description"
                        className={`${styles.textArea} form-control`}
                        name="description"
                        value={formData.description}
                        onChange={(e) => handleFormChange(e, setFormData)}
                        rows={5}
                        placeholder="Description "
                    />
                    <br />
                    <div className={styles.submitBtnBox}>
                        <Button
                            className={styles.submitBtn}
                            color="primary"
                            type="submit"
                        >
                            Submit
                        </Button>
                    </div>
                </Form>
            </Card>

            {/* Active Issues */}
            <ReactTable
                data={issues}
                columns={columns}
                showPagination
                isLoading={isLoading}
            />
        </Container>
    );
}
